import { FC, useMemo } from 'react';
import { Dialog } from './Dialog';
import { IActionsProps, IActionVariant } from './ButtonPanel';

export interface YesNoDialogProps {
  open: boolean;
  message: string;
  /**on dialog close */
  onClose?: () => void;
  onYes: () => void;
  onNo: () => void;
  title?: string;
  yesButtonName?: string;
  noButtonName?: string;
  /**Use decisions button style instead of material-ui button style */
  actionVariant?: IActionVariant;
}

export const YesNoDialog: FC<YesNoDialogProps> = ({
  noButtonName,
  yesButtonName,
  onNo,
  onYes,
  open,
  title,
  actionVariant,
  message,
  onClose,
}) => {
  const actions: IActionsProps[] = useMemo(
    () => [
      { name: noButtonName || 'No', onClick: onNo },
      { name: yesButtonName || 'Yes', onClick: onYes },
    ],
    [noButtonName, onNo, onYes, yesButtonName]
  );

  return (
    <Dialog
      open={open}
      onClose={onClose || onNo}
      dialogTitle={{ titleText: title }}
      dialogActions={{ actions, variant: actionVariant }}
      styles={{ minWidth: 350 }}
      disableFullScreenAction
      isResponsive
    >
      {message}
    </Dialog>
  );
};
